import React from 'react'

interface BodyTextContainerProps {
  children: React.ReactNode
}

export function BodyTextContainer({ children }: BodyTextContainerProps) {
  return <div className='l-body-text-container'>{children}</div>
}
